"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var TablePagination_styles_1 = __importDefault(require("./TablePagination.styles"));
var TablePagination = function (_a) {
    var range = _a.range, setPage = _a.setPage, page = _a.page, slice = _a.slice;
    react_1.useEffect(function () {
        if (slice.length < 1 && page !== 1) {
            setPage(page - 1);
        }
    }, [slice, page, setPage]);
    return range.length && range.length > 1 ? (react_1.default.createElement(TablePagination_styles_1.default, null,
        react_1.default.createElement("button", { className: classnames_1.default('item arrow arrow--left', page === 1 && 'item--hidden'), onClick: function () { return setPage(page - 1); } },
            react_1.default.createElement("svg", { className: "icon icon-filter", "aria-hidden": "true" },
                react_1.default.createElement("use", { xmlnsXlink: "http://www.w3.org/1999/xlink", xlinkHref: "/dist/svg/sprite.min.svg#arrow-left" }))),
        range.map(function (el, index) { return (react_1.default.createElement("button", { key: index, className: classnames_1.default('item', page === el && 'item--active'), onClick: function () { return setPage(el); } }, el)); }),
        react_1.default.createElement("button", { className: classnames_1.default('item arrow arrow--right', page === range.length && 'item--hidden'), onClick: function () { return setPage(page + 1); } },
            react_1.default.createElement("svg", { className: "icon icon-filter", "aria-hidden": "true" },
                react_1.default.createElement("use", { xmlnsXlink: "http://www.w3.org/1999/xlink", xlinkHref: "/dist/svg/sprite.min.svg#arrow-right" }))))) : (react_1.default.createElement(react_1.default.Fragment, null));
};
exports.default = TablePagination;
